var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCFooterWriteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2603 1.00414C21.0719 1.02691 20.8965 1.11296 20.7634 1.24845L9.61165 12.3943C9.3997 12.6061 9.31698 12.915 9.39464 13.2043C9.4721 13.4938 9.69806 13.7198 9.98745 13.7975C10.2769 13.875 10.5855 13.7922 10.7973 13.5804L18.6098 5.76611L19.8305 6.9871L6.86514 19.9559L5.64444 18.735L8.49555 15.883C8.7075 15.6712 8.79022 15.3623 8.71256 15.073C8.6351 14.7835 8.40914 14.5574 8.11975 14.4798C7.83034 14.4023 7.52166 14.4851 7.3097 14.6969L3.66513 18.3425C3.52247 18.4846 3.43567 18.6734 3.42107 18.8743L3.00243 24.0986C2.98375 24.3437 3.07347 24.5845 3.24805 24.7576C3.42263 24.9305 3.66436 25.0181 3.90922 24.9969L9.13233 24.5783C9.32891 24.5639 9.51419 24.4804 9.65549 24.3428L26.7538 7.24003C26.9114 7.08293 27 6.86957 27 6.64708C27 6.42457 26.9114 6.21102 26.7538 6.05393L21.9408 1.24864C21.7628 1.06837 21.5127 0.978626 21.2606 1.00433L21.2603 1.00414ZM21.3475 3.01881L24.9747 6.64693L23.414 8.20799L19.7868 4.58865L21.3475 3.01881ZM21.0162 8.17336L22.2281 9.39434L9.26279 22.3542L8.05066 21.1418L21.0162 8.17336ZM4.98166 20.444L7.56263 23.0256L4.75491 23.2523L4.98166 20.444Z",
    fill: "#407EDB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCFooterWriteOn);
export default __webpack_public_path__ + "static/media/icon_c_footer_write_on.13b14dfe1d6b0877e88e59c81a7667a2.svg";
export { ForwardRef as ReactComponent };